export const actionTypePrefix = '@@BirthdayPopup';
export const reduxKey = '@@BirthdayPopup';

//# sourceMappingURL=constants.js.map